import React from 'react';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../../redux/hooks';
import ROLES from '../../../../../utils/roles';
import AdminLearningLifecycleDashboard from './learning-lifecycle/AdminLearningLifecycleDashboard';
import AdminDashboardSkeleton from './learning-lifecycle/AdminDashboardSkeleton';
import { MOBILE_SX } from '../../../../../mobile/mobileApp';
import UserProgramBoard from './UserProgramBoard';

const ProgramTable: React.FC = () => {
  const { id: paramId = '' } = useParams();
  const role = localStorage.getItem('role') || '';
  const selectedGroup = useAppSelector((state) => state.selectedGroup.data);
  const orgLevelGrpId = useAppSelector((state) => state.orgLevelGroup.data?.grpId);

  // The Learning Framework dashboard is GA for every org — the
  // `learningLifecycleDashboard` flag is no longer read, so an org whose
  // details fail to load no longer falls back to the legacy board. The
  // skeleton below only covers the first paint while the org details resolve.
  const orgDetailsResolved = useAppSelector((state) => state.orgDetails.data !== undefined || state.orgDetails.error);

  const isAdminRoute = paramId === 'admin';
  const isPlatformAdmin = role === ROLES.platAdmin;
  const isOrgAdminOnDashboard = role === ROLES.orgAdmin && !!orgLevelGrpId && paramId === orgLevelGrpId;
  const isAdminView = isAdminRoute || selectedGroup?.role === 'admin' || isPlatformAdmin || isOrgAdminOnDashboard;

  if (isAdminView) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          overflow: 'hidden',
          // The phone's content area scrolls the dashboard (and its sticky stage tabs).
          [MOBILE_SX]: { height: 'auto', overflow: 'visible' }
        }}
      >
        {!orgDetailsResolved ? <AdminDashboardSkeleton /> : <AdminLearningLifecycleDashboard />}
      </Box>
    );
  }

  return <UserProgramBoard />;
};

export default ProgramTable;
